import { ReactNode, useState, useEffect } from "react";
import { useDialog } from "app/hook";
import { DialogType } from "app/types";
import I18n from "common/i18n";
import { btnDelay, usePlaySound } from "common/utils";
import { ParentGate } from "features/parent/ParentGate";
import { PlanType, usePlan } from "features/subscription";
import { recordRegisterPromptShow } from "features/auth/registerAnalytics";

type Props = {
  children: ReactNode;
};

export const GuestPurchaseOverlay = ({ children }: Props) => {
  const plan = usePlan();
  const play = usePlaySound();
  const handleDialog = useDialog();
  const [gateVisible, setGateVisible] = useState(false);

  useEffect(() => {
    if (plan === PlanType.TRIAL) {
      recordRegisterPromptShow("guest_purchase");
    }
  }, [plan]);

  if (plan !== PlanType.TRIAL) {
    return <>{children}</>;
  }

  const handleClick = () => {
    btnDelay(() => {
      play();
      setGateVisible(true);
    });
  };

  const handleGateClose = () => setGateVisible(false);

  const handleGateConfirm = () => {
    setGateVisible(false);
    handleDialog({
      type: DialogType.PARENT_REGISTRATION,
      value: true,
      args: { redirectAfterSuccess: "/parent", source: "guest_purchase" },
    });
  };

  return (
    <>
      <div className="flex-col-el flex-1 min-h-0 relative">
        <div className="flex-col-el flex-1 min-h-0 pointer-events-none">{children}</div>
        <button
          type="button"
          onClick={handleClick}
          className="type-inherit-font absolute inset-0 flex-col-el items-center justify-center gap-3 cursor-pointer rounded-2xl bg-gray2-100/40 backdrop-blur-[2px] border-none alpha"
        >
          <span className="material-symbols-outlined type-display text-white">lock</span>
          <p className="type-text type-title text-white leading-tight">
            {I18n.t("MSG_GUEST_PURCHASE_OVERLAY_HINT")}
          </p>
        </button>
      </div>
      <ParentGate visible={gateVisible} confirm={handleGateConfirm} close={handleGateClose} />
    </>
  );
};
